import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomAppsSection } from './CustomAppsSection';
import { MachineAppSection } from './MachineAppSection';
import './styles/ApplicationLandingPage.css';
import type { Library } from '../../machinelogic/types';

interface ApplicationLandingPageProps {
  library: Library;
  openMachineLogicAppEditor: () => void;
  openMachineAppEditor: (pType: string, pView: string) => void;
  openPythonAppEditor: () => void;
}
/**
 * Creates a landing page
 * @param param
 * @param param.library - the library
 * @param param.openMachineLogicAppEditor - callback to open the machinelogic editor
 * @param param.openPythonAppEditor - callback to open the python editor
 * @param param.openMachineAppEditor - callback to open the machinelogic app editor
 */
export const ApplicationLandingPage: FC<ApplicationLandingPageProps> = observer(({ library, openMachineLogicAppEditor, openPythonAppEditor, openMachineAppEditor }) => {

  return(
    <div className='ml_application_landing_page'>
      <h1>Choose an application type</h1>
      <div>
        <label className='ml_application_landing_page_section_label'>Custom Apps</label>
        <CustomAppsSection library={library} openMachineLogicAppEditor={openMachineLogicAppEditor}  openPythonAppEditor={openPythonAppEditor}/>
      </div>
      <div>
        <label className='ml_application_landing_page_section_label'>Vention MachineApps</label>
        <MachineAppSection openMachineApp={openMachineAppEditor} />
      </div>
    </div>
  );
});
